import { useEffect, useState } from 'react'
import { supabase } from '../lib/supabase'
import { DEFAULT_LOGIN_THEME, isChristmasLoginActive, normalizeLoginTheme, type LoginThemeConfig } from '../lib/loginTheme'

export function useLoginTheme() {
  const [config, setConfig] = useState<LoginThemeConfig>(DEFAULT_LOGIN_THEME)
  const [clock, setClock] = useState(() => Date.now())
  useEffect(() => {
    let live = true
    const update = async () => {
      try {
        const { data, error } = await supabase.rpc('get_public_login_theme')
        if (error) throw error
        if (live) setConfig(normalizeLoginTheme(data))
      } catch {
        if (live) setConfig(DEFAULT_LOGIN_THEME)
      }
      if (live) setClock(Date.now())
    }
    void update()
    const interval = window.setInterval(() => { void update() }, 60_000)
    const onFocus = () => { if (document.visibilityState === 'visible') void update() }
    document.addEventListener('visibilitychange', onFocus)
    return () => {
      live = false
      window.clearInterval(interval)
      document.removeEventListener('visibilitychange', onFocus)
    }
  }, [])
  return isChristmasLoginActive(config, clock)
}
